import { ref, readonly } from 'vue'

const isDevMode = ref(false)

export const useDevMode = () => {
  const checkDevMode = () => {
    isDevMode.value = localStorage.getItem('devMode') === 'true'

    return isDevMode.value
  }

  const toggleDevMode = () => {
    isDevMode.value = !isDevMode.value
    localStorage.setItem('devMode', isDevMode.value.toString())

    if (isDevMode.value) {
      console.log('🚀 Dev Mode Enabled! Debug information will now be visible.')
    } else {
      console.log('👋 Dev Mode Disabled!')
    }

    return isDevMode.value
  }

  const setDevMode = (value: boolean) => {
    isDevMode.value = value
    localStorage.setItem('devMode', value.toString())

    return isDevMode.value
  }

  return {
    isDevMode: readonly(isDevMode),
    checkDevMode,
    toggleDevMode,
    setDevMode
  }
}
